<h4 mat-dialog-title>Редактирование группы</h4>
<app-close-button [formGroup]="groupForm" [dialogRef]="dialogRef"/>
@if (loading()) {
    <app-loader [isLoading]="loading()"/>
} @else {
    <mat-dialog-content>
        <form class="flex-column" [formGroup]="groupForm" (ngSubmit)="onSubmit()">
            <mat-form-field appearance="fill">
                <mat-label>Название</mat-label>
                <input matInput formControlName="name" />
            </mat-form-field>

            <!--            <app-common-dropdown [label]="'Компания'" [service]="companySelectorService" [formCtrl]="companyControl"/>-->
            <app-common-dropdown
                [label]="'Адрес'"
                [service]="locationSelectorService"
                [formCtrl]="locationControl"
                [searchBy]="'address'"
            />

            <div class="flex justify-between">
                <button mat-stroked-button class="w-40" color="basic" type="button" [disabled]="!group.data.id" (click)="deleteGroup(group.data.id)">Удалить</button>
                <button mat-flat-button class="w-40" color="primary" type="submit" [disabled]="!groupForm.valid">Сохранить</button>
            </div>
        </form>
    </mat-dialog-content>
}

